export const generateId = (prefix: string) => {
  const id = Math.floor(Math.random() * 10000000)
  return `${prefix}-${id}`
}
